import axios from "@/libs/axios";

export default {
    namespaced: true,
    state: {
        loading: false,
        brands: [],
        search: {
            brand_ids: []
        }
    },
    getters: {
        _loading(state) {
            return state.loading
        },
        _brands(state) {
            return state.brands
        }
    },
    mutations: {
        setLoading(state, status) {
            state.loading = status
        },
        setBrands(state, brands) {
            state.brands = brands
        }
    },
    actions: {
        getAll(context) {
            context.commit('setLoading', true)
            axios.get('/trendyol/brand', {params: context.state.search})
                .then(res => {
                    context.commit('setBrands', res.data.content)
                })
                .finally(() => {
                    context.commit('setLoading', false)
                })
        }
    }
}